(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seco-collection"] && !window.DesignMode) return;
  try {
      
// 数量セレクタの要素を取得
var quantityInput = document.getElementById('textbox');
var upButton = document.getElementById('up');
var downButton = document.getElementById('down');

// カートボタンのリンクを取得
var cartButton = document.querySelector('.catalog-button a');

// 数量を増やすボタンのイベントリスナー
upButton.addEventListener('click', function() {
    var maxQuantity = parseInt(stockElement.textContent); // 在庫数を取得
    var quantity = parseInt(quantityInput.value, 10);
    if (quantity < maxQuantity) {
        quantityInput.value = quantity + 1;
        // カートボタンのリンクを更新
        updateCartButtonLink();
    }
});

// 数量を減らすボタンのイベントリスナー
downButton.addEventListener('click', function() {
    var quantity = parseInt(quantityInput.value, 10);
    if (quantity > 1) {
        quantityInput.value = quantity - 1;
    }
    // カートボタンのリンクを更新
    updateCartButtonLink();
});

// 数量入力フィールドの変更を監視
quantityInput.addEventListener('change', function() {
    var maxQuantity = parseInt(stockElement.textContent);
    var quantity = parseInt(quantityInput.value, 10);
    if (!isNaN(quantity) && quantity > 0 && quantity <= maxQuantity) {
        updateCartButtonLink();
    } else {
        quantityInput.value = quantity > maxQuantity ? maxQuantity : 1; // 無効または在庫超過の場合は調整
    }
});

// カートボタンのリンクを更新する関数
function updateCartButtonLink() {
    var quantity = quantityInput.value;
    var url = cartButton.href;
    cartButton.href = url.replace(/(quantity=)\d+/, '$1' + quantity);
}

// ページが表示されたときに実行されるイベントリスナーを追加
window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
        quantityInput.value = 1;
        updateCartButtonLink();
    }
});

// リスト内のすべてのリンクを取得
var links = document.querySelectorAll('.catalog-cats li a');

// 価格を表示する要素とカートボタンのリンク、在庫を表示する要素を取得
var priceElement = document.getElementById('prod-price');
var stockElement = document.getElementById('stock');

// 各リンクにイベントリスナーを設定
links.forEach(function(link) {
    link.addEventListener('click', function(event) {
        event.preventDefault();

        // 他のすべてのリンクから 'current' クラスを削除
        links.forEach(function(otherLink) {
            otherLink.classList.remove('current');
        });

        // クリックされたリンクに 'current' クラスを追加
        this.classList.add('current');

        // クリックされたリンクの data-price 属性の値を表示する要素のテキストに設定
        var price = this.getAttribute('data-price');
        priceElement.textContent = price;

        // クリックされたリンクの data-sku 属性と在庫数を取得
        var sku = this.getAttribute('data-sku');
        var stock = parseInt(this.getAttribute('data-stock'), 10);

        // 在庫数に応じて表示とカートボタンを更新
        if (stock === 0) {
            stockElement.textContent = 'なし';
            cartButton.href = '#'; // 在庫なしの場合はカートへのリンクを無効化
            cartButton.classList.add('disabled'); // オプションでボタンを無効化するスタイルを適用
        } else {
            stockElement.textContent = stock + '個';
            cartButton.href = `/cart/add?id=${sku}&quantity=1`;
            cartButton.classList.remove('disabled'); // 無効化したスタイルを解除
        }

        // クリック後、inputの数量が在庫を超えていれば在庫数に調整
        var currentQuantity = parseInt(quantityInput.value, 10);
        if (currentQuantity > stock) {
            quantityInput.value = stock; // 在庫数以上の場合は在庫数にセット
        }

        // カートボタンのリンクを更新
        updateCartButtonLink();
    });
});

  } catch(e) { console.error(e); }
})();
      })();
